import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiUri, filterRequest } from "../../utilities/apiManager";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
}

export const getTermsConditions = createAsyncThunk(
  "termsConditions/getTermsConditions",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query } = args;
      const filter = filterRequest(args.filter);
      const { data } = await axios.get(
        `${apiUri}/settings/terms_conditions?page=${page}&size=${size}&query=${query}${filter}`,
        {
          headers: {
            'Content-Type': 'application/json',
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
            "Accept-Language": document.documentElement.lang,
          }
        }
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const createTermsConditions = createAsyncThunk(
  "termsConditions/createTermsConditions",
  async (args, thunkApi) => {
    try {
      const { data } = await axios.post(
        `${apiUri}/settings/terms_conditions`,
        args,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
            "Accept-Language": document.documentElement.lang,
          }
        }
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const deleteTermsConditions = createAsyncThunk(
  "termsConditions/deleteTermsConditions",
  async (args, thunkApi) => {
    try {
      const { data } = await axios.delete(
        `${apiUri}/settings/terms_conditions/${args._id}`,
        {
          headers: {
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
            "Accept-Language": document.documentElement.lang,
          }
        }
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
)

const termsConditionsSlice = createSlice({
  name: "termsConditions",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getTermsConditions.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getTermsConditions.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload.data?.data;
        state.itemsCount = payload.data?.itemsCount;
        state.pages = payload.data?.pages;
        state.error = null;
      })
      .addCase(getTermsConditions.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(createTermsConditions.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createTermsConditions.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.itemsCount++;
        state.data.push(payload.data);
        state.error = null;
      })
      .addCase(createTermsConditions.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(deleteTermsConditions.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteTermsConditions.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = state.data.filter(el => el._id !== payload.data._id);
        state.error = null;
      })
      .addCase(deleteTermsConditions.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
  }
});

export default termsConditionsSlice.reducer;